import { message } from 'antd'

import { request } from '@utils/request'
import { Type } from '@utils/tool'

import type { WidgetProps, InsideState } from './types'
export type ReviewsQuery = {
  productsId?: string
  page?: number
  pageSize?: number
  star?: number
  //1=包含，0=获取所有，接口默认0
  isWithImages?: 1 | 0
  //1=recomond 2 most rencent
  order?: 1 | 2
  //1=合并 0=不合并
  mergeMedia?: 1 | 0
}

/**
 * 获取商品评论
 */
export const getProductReviews = (params: ReviewsQuery) => {
  //@test delete params.productsId
  const { productsId } = params
  if (Type.isEmpty(productsId)) {
    return new Promise((_, reject) => {
      reject('products id is empty!')
    })
  }

  return request
    .get<WidgetProps>('/reviews/getProductReviews', {
      ...params,
      mergeMedia: 1
      //productsId: 874
    })
    .then((res) => {
      return res?.data
    })
  // .then((res) => {
  //   const mock = {
  //     reviewId: '12',
  //     avatar: '',
  //     username: 'HWRO',
  //     date: '2014-1-1',
  //     score: '5',
  //     title: 'DFDF',
  //     content: '121212121212121212',
  //     isLike: false,
  //     isUnlike: false,
  //     likes: 100,
  //     images: ['/', '/', '/', '/', '/', '/', '/', '/']
  //   }
  //   return Object.assign(res, { reviews: [mock] })
  // })
}

type AddReview = {
  score: string
  productsId: string
  skuId: string
  title?: string
  content?: string
  images?: string[]
  videos?: string[]
  nickname: string
}

/**
 * 增加商品评论
 */
export const addReview = (params: AddReview) => {
  return request
    .post('/reviews/addReview', params)
    .then((res) => {
      message.success('Success!')
      return res?.data
    })
    .catch((err) => {
      message.error(err.message)
      throw new Error(err)
    })
}

/**
 * 检查是否可以评论
 */
export const checkReview = (productsId: string, productsSkuId: string) => {
  return request
    .post<InsideState>('/reviews/checkCustomerCanReview', {
      productsId,
      productsSkuId
    })
    .then((res) => res?.data)
    .catch((err) => {
      message.error(err.message)
      //todo
      //throw new Error(err)
    })
}

/**
 * 评论点赞|踩
 */
export const setReviewLike = async (params: {
  reviewId: string
  isLike: string
  isUnlike: string
  productsId: string
}) => {
  const { productsId, ...rest } = params
  // await checkReview(productsId)
  return request
    .post('/reviews/reviewLike', rest)
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      message.error(err.message)
      throw new Error(err)
    })
}
